import styles from "./Toggle.module.css";

export default function Toggle({
  checked,
  defaultChecked,
  onChange,
  ariaLabel,
  id,
}) {
  return (
    <label className={styles.toggle} title={ariaLabel}>
      <input
        type="checkbox"
        id={id}
        checked={checked}
        defaultChecked={defaultChecked}
        onChange={onChange}
        aria-label={ariaLabel}
      />
      <span className={styles.slider} />
    </label>
  );
}
